import { forwardRef } from "react";
import { classNames } from "../../utils/classNames";

export const BreadcrumbItem = forwardRef<
  HTMLLIElement,
  React.ComponentPropsWithoutRef<"li"> & { truncate?: boolean }
>(function BreadcrumbItem({ className, truncate, ...props }, ref) {
  return (
    <li
      ref={ref}
      className={classNames(
        "inline-flex items-center gap-1.5",
        {
          "overflow-hidden [&>*]:truncate min-w-10": truncate,
        },
        className,
      )}
      {...props}
    />
  );
});
